import { pwInput, pwLabel } from "./policyWizardFieldStyles";

/** Optional applicability extra — limit policy to specific employee IDs. */
export default function PolicyApplicabilityIndividualEmployeesField({
  darkMode = false,
  value = "",
  onChange,
  disabled = false,
  label = "Individual employees (override — comma or space separated IDs)",
  placeholder = "e.g. EMP001, EMP002",
  helpText = null,
}) {
  return (
    <div className="mt-3">
      <label className={pwLabel(darkMode)}>{label}</label>
      {helpText && (
        <p className={`text-xs mb-2 ${darkMode ? "text-[hsl(var(--ds-muted-fg))]" : "text-[hsl(var(--ds-muted-fg))]"}`}>{helpText}</p>
      )}
      <input
        type="text"
        value={value}
        disabled={disabled}
        onChange={onChange}
        placeholder={placeholder}
        className={`${pwInput(darkMode)} ${disabled ? "opacity-50" : ""}`}
      />
    </div>
  );
}
